import React from "react";
import UserOrderDetails from "../../components/UserOrderDetails";

const ProfileUserOrderDetails = () => {
  return <UserOrderDetails />;
};

export default ProfileUserOrderDetails;
